export const TAGS_LOADING = 'TAGS_LOADING';
export const TAGS_FULFILLED = 'TAGS_FULFILLED';
